import { AlgorithmFormDataSchema } from './AlgorithmFormDataSchema';
import {
  AlgorithmFormDataType,
  AlgorithmMutationDtoType,
  AlgorithmValidFormDataType,
} from './types';
import { AlgorithmMutationDtoSchema } from './AlgorithmMutationDtoSchema';
import { AlgorithmValidFormDataSchema } from './AlgorithmValidFormDataSchema';

export class AlgorithmSchema {
  static parseFormData<Dto>(data: Dto): AlgorithmFormDataType {
    return AlgorithmFormDataSchema.parse(data);
  }

  static parseMutationDto<
    ValidFormData extends Partial<AlgorithmValidFormDataType>
  >(validFormData: ValidFormData): AlgorithmMutationDtoType {
    return AlgorithmMutationDtoSchema.parse(validFormData);
  }

  static validFormDataSchema = AlgorithmValidFormDataSchema;
}
